import React from 'react';
import FUNCIONALIDADES from '../data/martelinhoFuncionalidades';

const PERM_LABEL = {
  pode_habilitar: 'Venda sem estoque',
  pode_consultar_estoque_disponivel: 'Estoque disponível',
  pode_consultar_estoque_bruto: 'Estoque bruto',
  pode_consultar_lote: 'Lote de pisos',
  pode_bloquear_devolucao: 'Bloquear devolução',
  autorizar_pedido: 'Aprovar pedidos MK',
};

export default function MartelinhoFuncionalidades() {
  return (
    <div className="container py-4">
      <div className="mb-4">
        <h3 className="mb-1" style={{ color: 'var(--portal-text)' }}>Funcionalidades do Martelinho</h3>
        <p className="text-muted mb-0" style={{ fontSize: '0.85rem' }}>
          O que cada opção do menu do WhatsApp faz e qual permissão a libera.
        </p>
      </div>

      <div className="row g-3">
        {FUNCIONALIDADES.map((f) => (
          <div key={f.chave} className="col-12 col-lg-6">
            <div className="card h-100 p-3" style={{ border: '1px solid var(--portal-border)' }}>
              <div className="d-flex justify-content-between align-items-start gap-2 mb-2">
                <h5 className="mb-0" style={{ color: 'var(--portal-text)' }}>{f.titulo}</h5>
                <span
                  className="badge"
                  style={{ background: '#2A8A9C22', color: '#2A8A9C', border: '1px solid #2A8A9C55', whiteSpace: 'nowrap' }}
                >
                  {f.comando}
                </span>
              </div>
              <p style={{ fontSize: '0.85rem', color: 'var(--portal-muted)' }} className="mb-2">
                {f.descricao}
              </p>
              <div style={{ fontSize: '0.78rem', color: 'var(--portal-muted)' }}>
                <i className="bi bi-shield-lock me-1" />
                Permissão: <strong>{PERM_LABEL[f.permissao] || f.permissao}</strong>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
